import {
  pushSnackbarMessage,
  setContentLoading,
} from 'Modules/Shared/actions/app';
import { call, put } from 'redux-saga/effects';
import { history } from 'Utils/history';
import { getLdClient } from 'Utils/ldClient';

export function* upstart() {
  yield put(setContentLoading(true));
  if (!getLdClient().variation('plays')) {
    yield put(
      pushSnackbarMessage({
        message: 'You do not have access to plays',
      })
    );
    yield call(history.push, '/');
    return;
  }
  yield put(setContentLoading(false));
}
